import http from './http';

/**
 * 标签相关接口
 */

/** 获取单个文件的标签 */
export function getFileTags(fileId) {
  return http.get(`/api/tag/${encodeURIComponent(fileId)}`);
}

/** 保存单个文件的标签（payload: { action: 'add'|'remove'|..., tags: [...] }） */
export function saveFileTags(fileId, payload) {
  return http.post(`/api/tag/${encodeURIComponent(fileId)}`, payload);
}

/** 标签自动补全，params: { prefix, limit } */
export function autocomplete({ prefix, limit = 20 } = {}) {
  return http.get('/api/tag/autocomplete', { params: { prefix, limit } });
}

/** 批量标签操作 */
export function batch(payload) {
  return http.post('/api/tag/batch', payload);
}
